:host {
  display: block;
}

.bumps__list {
  display: grid;
  gap: 10px;
}
